export default {

    paginas:[
        {
            tipotela:'telacheia',
            htmlContentEsquerda:{
                titulo:`Ficha Digital e Web Check in`,
                subtitulo:`(Utilizacao)`
            },
            htmlContentDireita:{
                conteudo:``
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/1-Login.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Login</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/2-tela-listagem-fichas.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Tela Principal do Ficha - Listagem de Reservas</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/3-Criando-ficha-ADMH-E-Enviando-para-FD-automaticamente.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Criando uma Reserva no ADMH e Enviado para o Ficha Digital Automaticamente</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/4-Criando-ficha-ADMH-E-Enviando-para-FD-manualmente.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Enviando Manualmente</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/5-funcionamento-do-envio-do-link-do-webcheckin.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Funcionamento do Envio do link do web checkin.</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/6-como-o-email-eh-enviado.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Como o email é enviado</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/7-acesso-da-recepcao-ao-link-do-webcheckin.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Como a Recepção acessa o link do webcheckin</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/8-preenchendo-webcheckin.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Preenchendo o Web Checkin</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/9-checando-os-dados-sincronizado-de-volta-no-ADMH.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Checando os dados sincronizados no ADMH</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/10-preenchendo-o-web-checkin.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Preenchendo o web checkin na Recepção</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/11-coletando-documento-assinatura-recepcao.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Coletando Documentos e Assinatura pela Recepção</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/12-funcionalidades-extras.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Funcionalidades Extras</h1>
            `
            }
        },
        {
            tipotela:'telacomvideo',
            htmlContentEsquerda:{
                img:'/Treinamentos/pc-apresentacao.jpg',
                css:'width:90%!important;height:90%!important;',
                linkVideo:'https://esvideos.economysoftware.com.br/videos/tutoriais/fichadigital/admh/13-outras-formas-de-alcançar-o-hospede.mp4'
            },
            htmlContentDireita:{
                conteudo:`<h1>Outras maneiras de alcançar o Hospede</h1>
            `
            }
        },
        {
            tipotela:'telacheia',
            htmlContentEsquerda:{
                titulo:`Obrigado!!`,
                subtitulo:``
            },
            htmlContentDireita:{
                conteudo:``
            }
        },
    ]

}